import { CurrentRefinements } from 'react-instantsearch-dom'
import { useRouter } from 'next/router'

export default function CurrentRefinementsCompomnent() {
    const router = useRouter()
    const { query } = router.query

    const handleClearQuery = () => {
        router.push(`/paieska`)
    }

    return (
        <div className="ais-CurrentRefinements-group">
            {query && (
                <div className="ais-CurrentRefinements">
                    <ul className="ais-CurrentRefinements-list ais-CurrentRefinements-query">
                        <li className="ais-CurrentRefinements-item">
                            <span className="ais-CurrentRefinements-label">Paieškos frazė: {query}</span>
                            <span className="ais-CurrentRefinements-category">
                                <button onClick={handleClearQuery} className="ais-CurrentRefinements-delete">
                                    ✕
                                </button>
                            </span>
                        </li>
                    </ul>
                </div>
            )}
            <CurrentRefinements
                className="mb30"
                clearsQuery
                transformItems={items =>
                    items.map(item => {
                        if (item.id === 'brand_name') {
                            item.label = 'Prekės ženklas: '
                        }
                        if (item.id === 'price_from') {
                            item.label = item.label.replace('price_from', 'Kaina')
                        }
                        if (item.id === 'all_features') {
                            item.label = item.label.replace('all_features', 'Išskirtinumai')
                        }
                        if (item.id === 'all_audiences') {
                            item.label = item.label.replace('all_audiences', 'Kam skirta')
                        }
                        if (item.id === 'hierarchical_taxonomies.lvl0') {
                            item.label = item.label.replace('hierarchical_taxonomies.lvl0', 'Kategorija')
                        }
                        return item
                    })
                }
            />
        </div>
    )
}
